import axios from 'axios';

export const axiosRef = axios.create({
  baseURL: process.env.REACT_APP_NODE_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
